module.exports = __webpack_public_path__ + "04ca04ce3c08b16fceff52467be65a1e.pdf";